import { UserRepository } from "../../../api";

export class Auth {

	constructor(auth = {}) {
		// this.cep = auth.cep;
		this.companyName 						= auth.company_name;
		this.cnpj								= auth.cnpj;
		this.atividade							= auth.atividade;
		this.site								= auth.site;
		this.address 							= { ...auth.address };
		this.done 								= { ...auth.done };
		this.email 								= auth.email;
		this.nameUser 							= auth.name_user;
		this.quantStaff 						= auth.quant_staff;
		this.role 								= auth.role;
		this.userId 							= auth.user_id;
		this.reportUrl 							= auth.report_url;
		this.governanceResponsibilitiesPoints 	= { ...auth.governanceResponsibilitiesPoints };
		this.businessPlanningPoints 			= { ...auth.businessPlanningPoints };
		this.engagementPoints 					= { ...auth.engagementPoints };
		this.comunicationPoints 				= { ...auth.comunicationPoints };
		this.waterTreatmentPoints 				= { ...auth.waterTreatmentPoints };
		this.measurementSectorizationPoints 	= { ...auth.measurementSectorizationPoints };
		this.effluentTreatmentPoints 			= { ...auth.effluentTreatmentPoints };
		this.inputPoints 						= { ...auth.inputPoints };
		this.othersPoints 						= { ...auth.othersPoints };
	}

	isDone(category) {
		return this.done[category];
	}

	async updateUser() {
		const authRepo = new UserRepository();
		const newUser = await authRepo.edit(this.userId, this.mapToApi(this));
		this.mapToConsole(newUser.data);
	}

	mapToConsole(data) {

		this.companyName 						= data.company_name;
		this.cnpj								= auth.cnpj;
		this.atividade							= auth.atividade;
		this.site								= auth.site;
		this.address 							= { ...data.address };
		this.done 								= { ...data.done };
		this.email 								= data.email;
		this.nameUser 							= data.name_user;
		this.quantStaff 						= data.quant_staff;
		this.role 								= data.role;
		this.userId 							= data.user_id;
		this.governanceResponsibilitiesPoints 	= { ...data.governanceResponsibilitiesPoints };
		this.businessPlanningPoints 			= { ...data.businessPlanningPoints };
		this.engagementPoints 					= { ...data.engagementPoints };
		this.comunicationPoints 				= { ...data.comunicationPoints };
		this.waterTreatmentPoints 				= { ...data.waterTreatmentPoints };
		this.measurementSectorizationPoints 	= { ...data.measurementSectorizationPoints };
		this.effluentTreatmentPoints 			= { ...data.effluentTreatmentPoints };
		this.inputPoints 						= { ...data.inputPoints };
		this.othersPoints 						= { ...data.othersPoints };

	}

	async updatePassword(password, newPassword, token) {
		const authRepo = new UserRepository();
		const newUser = await authRepo.editPassword(this.userId, token, { password, newPassword });
		return newUser;
	}

	mapToApi(auth) {
		return {
			company_name  						: auth.companyName,
			cnpj								: auth.cnpj,
			atividade							: auth.atividade,
			site								: auth.site,
			address								: { ...auth.address },
			done  								: { ...auth.done },
			email  								: auth.email,
			name_user  							: auth.nameUser,
			quant_staff  						: auth.quantStaff,
			role  								: auth.role,
			user_id  							: auth.userId,
			governanceResponsibilitiesPoints  	: { ...auth.governanceResponsibilitiesPoints },
			businessPlanningPoints  			: { ...auth.businessPlanningPoints },
			engagementPoints  					: { ...auth.engagementPoints },
			comunicationPoints  				: { ...auth.comunicationPoints },
			waterTreatmentPoints  				: { ...auth.waterTreatmentPoints },
			measurementSectorizationPoints  	: { ...auth.measurementSectorizationPoints },
			effluentTreatmentPoints  			: { ...auth.effluentTreatmentPoints },
			inputPoints  						: { ...auth.inputPoints },
			othersPoints  						: { ...auth.othersPoints },
		};
	}
}


// WEBPACK FOOTER //
// src/models/lib/entities/Auth.js